export default "__VITE_ASSET__b80ecb69__"